import * as yup from "yup"
import { formSalesOrderSchema } from "pages/Sales/Transaction/CustomerOrder/types"
import { formInvoiceDetailSchema } from "./FormInvoiceDetail"

export type FormInvoiceType = yup.InferType<typeof formInvoiceSchema>

export const formInvoiceSchema = formSalesOrderSchema
  .omit(["sodetail", "approval_status_text"])
  .shape({
    invoice_id: yup.number().label("Sales Order").optional(),
    delivery_status: yup.number().label("Delivery Status").required(),
    delivery_no: yup.number().label("Delivered").required(),
    link: yup.string().label("Link").required(),
    employee_id: yup.number().label("Employee Id").optional(),
    sodetail: yup.array().of(formInvoiceDetailSchema),
    invoice_status_text: yup.string().label("Invoice Status"),
    total_payment: yup.number().label("Total Payment").optional(),
    invoice_detail: yup
      .array()
      .of(formInvoiceDetailSchema)
      .label("Invoice detail")
      .min(1)
      .required(),
    imgPath: yup.array().of(yup.object().shape({
      file_path: yup.string().required(),
    })).label("FILE").min(0).optional().nullable(),

  })
